import Clarity from "@microsoft/clarity";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  if (config.public.CLARITY_PROJECT_ID === "disabled") {
    return {};
  }

  Clarity.init(config.public.CLARITY_PROJECT_ID);

  return {
    provide: {
      clarity: Clarity,
    },
  };
});
